module.exports = __webpack_public_path__ + "img/single-img-3_1single-img-3.8adaa710.png";